import { render, staticRenderFns } from "./ip-restricted.vue?vue&type=template&id=74cd6bc5&"
import script from "./ip-restricted.vue?vue&type=script&lang=js&"
export * from "./ip-restricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports